import Typography from '@ui/typography'
import { getEnvSetting } from 'config/getEnvValue'
import { Platform, View } from 'react-native'
import { AppVersionProps } from './types'
import { DEFAULT_REGION } from '@ca/common'
import { DEFAULT_DEAL_TYPES } from '@ca/common/types'
import Status from '@ui/elements/Status'
import Loader from '@ui/elements/Loader'
import Chip from '@ui/elements/Chip/Chip'

const ConfigDetails = {
  DEAL_TYPES: getEnvSetting('DEAL_TYPES', DEFAULT_DEAL_TYPES.join(',')),
  REGION: getEnvSetting('REGION', DEFAULT_REGION),
  API_URL: getEnvSetting('API_URL'),
  DEV: getEnvSetting('PARAM_DEV'),
} as const

const RemoteConfigItem = ({
  name,
  config,
}: {
  name: string
  config: ReturnType<typeof getEnvSetting>
}) => {
  return (
    <View className={sContainer}>
      <Typography variant={Platform.select({ default: 'XSB', web: 'SMB' })}>
        {name}
      </Typography>
      <View className={sList}>
        {Object.entries(config)
          .filter(([_, v]) => v !== 'n/a')
          .map(([k, v]) => (
            <Chip
              key={k}
              label={k}
              value={v || 'undefined'}
              styleText={{ opacity: v ? 1 : 0.25 }}
            />
          ))}
      </View>
    </View>
  )
}

const AppConfigItem = (props: AppVersionProps & { index: number }) => {
  const { title, status, rows, loading } = props

  const value = rows[0].value

  return (
    <View className={sContainer}>
      <Typography variant={Platform.select({ default: 'XSB', web: 'SMB' })}>
        {title}
      </Typography>
      {loading && <Loader loading />}
      {!loading && (
        <View className={sList}>
          <Chip
            value={value?.toString() || 'undefined'}
            styleText={{ opacity: value ? 1 : 0.25 }}
          />
          {status && <Status text={status.text} variant={status.variant} />}
        </View>
      )}
    </View>
  )
}

const AppConfigDetails = ({ apps }: { apps: AppVersionProps[] }) => {
  const keys = Object.keys(ConfigDetails) as (keyof typeof ConfigDetails)[]

  return (
    <View className="flex flex-col gap-8 pt-8">
      {apps.map((app, index) => (
        <AppConfigItem key={app.title} {...app} index={index} />
      ))}
      {keys.map((key) => (
        <RemoteConfigItem key={key} name={key} config={ConfigDetails[key]} />
      ))}
    </View>
  )
}

const sContainer =
  'flex flex-row items-start justify-between gap-4 border-b border-black/10 px-8 pb-8'

const sList = 'flex-1 flex flex-row flex-wrap gap-4 justify-end w-full'

export default AppConfigDetails
